const CLIENT_ID = '36f73f6d-e0dd-45c2-9e48-f7ad3b62abdd';
const API_ID = '459be339-53e4-4370-8aee-30df3d416556';

export const environment = {
  production: true,
  appVersion: require('../../package.json').version,
  msalConfig: {
    auth: {
      clientId: CLIENT_ID,
      authority: `https://login.microsoftonline.com/0e3d950c-f028-43ec-963b-c060275e6bbc`,
      redirectUri: 'https://dev.backoffice.time.eliorgroup.com',
      postLogoutRedirectUri: 'https://dev.backoffice.time.eliorgroup.com',
      loginFailedRoute: '/login-failed',
      graphApiScopes: ['User.Read', 'User.ReadBasic.All'],
      apiScopes: [`api://${API_ID}/fullaccess`],
    },
  },
  apiConfig: {
    webApiUri: 'https://dev.api.backoffice.time.eliorgroup.com'
  },
  signalRConfig: {
    hubEndpoint: 'https://dev.api.backoffice.time.eliorgroup.com/api/v1/hubs'
  }
};
